import React from "react";

const Users = () => {
	return (
		<>
			<div className="flex justify-between gap-2 py-2">
				<p className="text-gray-200 text-sm font-semibold">
					<i className="fal fa-users font-semibold px-1"></i>Perticipets
				</p>
				<p className="text-gray-200 text-sm font-semibold">
					<i className="fal fa-users font-semibold px-1"></i>Invite
				</p>
			</div>
			<div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hossain Srkar
					</p>
				</div>

				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Alamin Sarkar
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Rokbul Islam Roctim{" "}
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>

				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
				<div className="avatar">
					<div className="w-full rounded-md">
						<img
							src="https://placeimg.com/192/192/people"
							alt="Slide user"
							className="rounded-xl"
						/>
					</div>
					<i className="fal fa-microphone font-bold text-md text-gray-200 bg-green-400 p-1 absolute top-2 left-2 rounded-md"></i>
					<p className="text-gray-300 bg-user-transparent px-1 absolute bottom-2 right-1 rounded">
						Md. Hasan Mia
					</p>
				</div>
			</div>
		</>
	);
};

export default Users;
